'use client';

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';
import AlertModal from '@/components/ui/AlertModal';
interface AlertOptions {
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm?: () => void;
}
interface ModalContextType {
  showAlert: (options: AlertOptions) => void;
  hideAlert: () => void;
}
const ModalContext = createContext<ModalContextType | undefined>(undefined);
export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
};
export const ModalProvider: React.FC<{
  children: ReactNode;
}> = t0 => {
  const $ = _c(12);
  const {
    children
  } = t0;
  const [alertConfig, setAlertConfig] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = options => {
      setAlertConfig(options);
      setIsOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const showAlert = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsOpen(false);
      setTimeout(() => setAlertConfig(null), 300);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const hideAlert = t2;
  let t3;
  if ($[2] !== alertConfig) {
    t3 = () => {
      if (alertConfig?.onConfirm) {
        alertConfig.onConfirm();
      }
      hideAlert();
    };
    $[2] = alertConfig;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleConfirm = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      showAlert,
      hideAlert
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== alertConfig || $[6] !== handleConfirm || $[7] !== isOpen) {
    t5 = alertConfig && <AlertModal isOpen={isOpen} title={alertConfig.title} message={alertConfig.message} confirmLabel={alertConfig.confirmLabel} onConfirm={handleConfirm} onClose={hideAlert} />;
    $[5] = alertConfig;
    $[6] = handleConfirm;
    $[7] = isOpen;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children || $[10] !== t5) {
    t6 = <ModalContext.Provider value={t4}>{children}{t5}</ModalContext.Provider>;
    $[9] = children;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};